<div class="mapa-flotante">
  <app-flotante-sirenas
    [sirenasLength]="sirenas?.length"
    [sirenasOnline]="sirenasOnline"
    [sirenasOffline]="sirenasOffline"
    (clusterChange)="onClusterToggle($event)"
  ></app-flotante-sirenas>
</div>
<app-mapa-facil-v2
  [zoom]="currentZoom"
  [style]="tipoMapaBase"
  [mapId]="nombreMap"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
